import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { DropdownMenuTrigger } from '../../patched-dropdown/Dropdown.mjs';

const DropdownTrigger = forwardRef((props, forwardedRef) => {
  return /* @__PURE__ */ jsx(
    DropdownMenuTrigger,
    {
      "data-scope": "dropdown",
      "data-part": "trigger",
      ref: forwardedRef,
      ...props
    }
  );
});

export { DropdownTrigger };
//# sourceMappingURL=Trigger.mjs.map
